import React from "react";
import {
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  IconButton,
  Tooltip,
  Avatar,
  Paper,
  TableContainer,
} from "@mui/material";
import {
  Edit as EditIcon,
  Block as BlockIcon,
  Delete as DeleteIcon,
  Person as PersonIcon,
} from "@mui/icons-material";
import { Banker } from "../../../validation/banker.validations";
import ConfirmDeleteDialog from "../../../common/confirmDeleteAlert";
import ConfirmBlockDialog from "../../../common/confirmBlockAlert";
import { formatPhoneNumber } from "../../../helper/phoneFormatter.helper";

interface Props {
  bankers: Banker[];
  onDelete: (emp: Banker) => void;
  onEdit: (emp: Banker) => void;
  onBlock: (emp: Banker) => void;
  user?: any;
}

const BankerTableView: React.FC<Props> = ({ bankers, onDelete, onEdit, onBlock, user = null }) => {
  const [openDialog, setOpenDialog] = React.useState(false);
  const [openStatusDialog, setOpenStatusDialog] = React.useState(false);
  const [selectedBanker, setSelectedBanker] = React.useState<Banker | null>(null);

  const handleOpenDialog = (emp: Banker) => {
    setSelectedBanker(emp);
    setOpenDialog(true);
  };

  const handleDelete = () => {
    if (selectedBanker) {
      onDelete(selectedBanker);
    }
    setOpenDialog(false);
    setSelectedBanker(null);
  };

  const handleEdit = (emp: Banker) => {
    onEdit(emp);
  };

  const openDeactivateDialog = (emp: Banker) => {
    setSelectedBanker(emp);
    setOpenStatusDialog(true);
  };

  const handleStatusConfirm = () => {
    if (selectedBanker) {
      onBlock(selectedBanker);
    }
    setOpenStatusDialog(false);
    setSelectedBanker(null);
  };

  return (
    <>
      <div className="overflow-x-auto">
        <TableContainer component={Paper} sx={{ borderRadius: 3, minWidth: 600 }}>
        <Table sx={{ borderCollapse: "collapse" }}>
          <TableHead>
            <TableRow sx={{ backgroundColor: "#f9fafb" }}>
              <TableCell
                sx={{ fontWeight: "bold", border: "1px solid #e5e7eb" }}
              >
                Name
              </TableCell>
              <TableCell
                sx={{ fontWeight: "bold", border: "1px solid #e5e7eb" }}
              >
                Email
              </TableCell>
              <TableCell
                sx={{ fontWeight: "bold", border: "1px solid #e5e7eb" }}
              >
                Phone
              </TableCell>
              <TableCell
                sx={{
                  fontWeight: "bold",
                  border: "1px solid #e5e7eb",
                  textAlign: "center",
                }}
              >
                Actions
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {bankers.map((banker) => (
              <TableRow
                key={banker?.id}
                hover
                className={banker.isActive === false ? "bg-gray-100" : ""}
              >
                <TableCell
                  sx={{
                    border: "1px solid #e5e7eb",
                    display: "flex",
                    alignItems: "center",
                    gap: 1,
                  }}
                >
                  <Avatar
                    sx={{
                      bgcolor: "#f3f4f6",
                      color: "#6b7280",
                      width: 32,
                      height: 32,
                    }}
                  >
                    <PersonIcon fontSize="small" />
                  </Avatar>
                  {`${(banker as any).firstName || ''} ${(banker as any).middleName || ''} ${(banker as any).lastName || ''}`.trim() || (banker as any).name || "-"}
                </TableCell>
                <TableCell sx={{ border: "1px solid #e5e7eb" }}>
                  {banker.email || "-"}
                </TableCell>
                <TableCell sx={{ border: "1px solid #e5e7eb" }}>
                  {banker.phone ? formatPhoneNumber(banker.phone) : "-"}
                </TableCell>
                <TableCell
                  sx={{
                    border: "1px solid #e5e7eb",
                    textAlign: "center",
                    whiteSpace: "nowrap",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "center",
                      gap: 4,
                    }}
                  >
                    <Tooltip title="Edit">
                      <IconButton
                        color="secondary"
                        size="small"
                        onClick={() => handleEdit(banker)}
                      >
                        <EditIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Deactivate">
                      <IconButton
                        size="small"
                        sx={{ color: "#f59e0b" }}
                        onClick={() => openDeactivateDialog(banker)}
                      >
                        <BlockIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                    <Tooltip title="Delete">
                      <IconButton
                        color="error"
                        size="small"
                        onClick={() => handleOpenDialog(banker)}
                      >
                        <DeleteIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </div>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      </div>

      <ConfirmDeleteDialog
        open={openDialog}
        onClose={() => setOpenDialog(false)}
        onConfirm={handleDelete}
        itemName={selectedBanker?.name || ""}
      />

      <ConfirmBlockDialog
        open={openStatusDialog}
        isActive={!!selectedBanker?.isActive}
        onClose={() => setOpenStatusDialog(false)}
        onConfirm={handleStatusConfirm}
        itemName={selectedBanker?.name}
      />
    </>
  );
};

export default BankerTableView;
